import {
  EM_SIG_MAXIMUM_HALF_WIDTH_CONTACT_FIELD_LENGTH,
  EmailSignatureContactDetailsFieldWidth,
} from '@components/EmailSignaturev2/consts';

export function deriveFieldWidth(contactFieldWidth: number): EmailSignatureContactDetailsFieldWidth {
  if (contactFieldWidth > EM_SIG_MAXIMUM_HALF_WIDTH_CONTACT_FIELD_LENGTH) {
    return EmailSignatureContactDetailsFieldWidth.FULL_WIDTH;
  } else {
    return EmailSignatureContactDetailsFieldWidth.HALF_WIDTH;
  }
}
